import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import SocialContainer from '../../components/SocialContainer'
import routes from '../../config/routes'
import SocialGroup from '../../models/SocialModel'
import Button from '../Button'
import Icon from '../Icon'
import Text from '../Text'
import { Apps, Container, Copyright, Link, Links } from './styles'
interface Props {

}

const Footer: React.FC<Props> = () => {
  const [socialUrl] = useState(`${process.env.REACT_APP_API_URL}/social`)
  const [socials, setSocials] = useState<SocialGroup[]>([])
  const [googleStore, setGoogleStore] = useState<SocialGroup>()
  const [appleStore, setAppleStore] = useState<SocialGroup>()
  const { token } = useAuth()

  useEffect(() => {
    let mounted = true
    Axios({
      method: 'GET',
      url: socialUrl,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(({ data }) => {

      if (mounted && data.data) {
        const soc: SocialGroup[] = []
        data.data.map((item: SocialGroup) => {
          if (item.social !== 'google_store' && item.social !== 'apple_store')
            soc.push(item)
          if (item.social === 'google_store')
            setGoogleStore(item)
          if (item.social === 'apple_store')
            setAppleStore(item)
          return item
        })

        setSocials(soc)
      }
    })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <>
      <Container>
        <Links>
          <Link>
            <RouterLink
              to={routes.faq.path}
            >
              Perguntas Frequentes
            </RouterLink>
          </Link>
          <Link>
            <RouterLink
              to={routes.contact.path}
            >
              Fale Conosco
            </RouterLink>
          </Link>
          <Link>
            <a
              href="https://cdn.iptu.app/assets/docs/manual-usuario-iptu.pdf"
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
            >Manual do Usuário</a>
          </Link>
          {/* <Link>
            <a
              href="https://iptu.app/terms"
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
            >Termos de Utilizaçao</a>
          </Link> */}
          <Link>
            <RouterLink
              to={routes.terms.path}
            >
              Termos de Utilizaçao
            </RouterLink>
          </Link>
          <Link>
            <RouterLink
              to={routes.privacy.path}
            >
              Política de Privacidade
            </RouterLink>
          </Link>
        </Links>

        <Apps>
          <Button
            before={(
              <Icon
                name="google-play"
              />
            )}
            label="Google Play"
            backgroundColor="transparent"
            fontColor="white"
            borderColor="white"
            onClick={() => {
              if (googleStore)
                window.open(googleStore.url)
            }}
          />
          <Button
            before={(
              <Icon
                name="apple"
              />
            )}
            label="App Store"
            backgroundColor="transparent"
            fontColor="white"
            borderColor="white"
            onClick={() => {
              if (appleStore)
                window.open(appleStore.url)
            }}
          />
        </Apps>
        <SocialContainer
          socials={socials as SocialGroup[]}
        />
      </Container>

      <Copyright>
        <Text
          tag="span"
          color="darkGray"
        >
          © IPTU.app - Todos os direitos reservados
        </Text>
      </Copyright>
    </>
  )
}

export default Footer
